import { cloneDeep } from 'lodash';
import { unit } from 'mathjs';
import { s2ms as secondToStr } from './day';
/******************* 配速转换 **********************/
/**
 * 将配速单位为（秒/千米）的数值，转换为指定配速单位的秒值，如'min/km' 秒值为's/km'
 *
 * @param {String} unitName 目标单位
 * @param {Number} value 数值
 * @param {Number} fix 保留小数点
 * @returns
 */
export const paceSKmToOther = (unitName, value, fix = 2) => {
  let result = 0;
  value = Number(value);

  // 实际上时间单位均为秒
  switch (unitName) {
    case 'min/km':
      result = Number(value.toFixed(fix));
      break;
    case 'min/mi':
      result = paceKm2Mile(value, fix);
      break;
    case 's/100m':
      result = paceKmTo100m(value, fix);
      break;
  }
  return result;
};
/**
 * 将指定的单位的秒值转换成s/km的值，如'min/km' 秒值为's/km'，'min/mi' 秒值为's/mi'
 *
 * @param {String} unitName 原单位名
 * @param {Number} value 时间(秒)
 * @param {Number} fix 保留小数
 * @returns Number
 */
export const paceToSKm = (unitName, value, fix = 2) => {
  let result = 0;
  value = Number(value);

  // 实际上时间单位均为秒
  switch (unitName) {
    // s/km
    case 'min/km':
      result = Number(value.toFixed(fix));
      break;
    // s/mi
    case 'min/mi':
      result = unit(value, 's/mi').toNumber('s/km').toFixed(fix);
      break;
    // s/100m
    case 's/100m':
      result = unit(value, 's/hm').toNumber('s/km').toFixed(fix);
      break;
  }
  return result;
};
//  配速的秒/千米转换成秒/英里
export const paceKM2mile = (m = 0, fix = 2, unit = Vue.prototype.$unit) => {
  if (unit === 0) {
    return Number(m.toFixed(fix));
  }
  return Number((m * 1.609344).toFixed(fix));
};

//  配速的秒/千米转换成秒/英里
export const paceKm2Mile = (m = 0, fix = 2) => {
  return Number((m * 1.609344).toFixed(fix));
};

//  配速的秒/英里转换成秒/千米
export const paceMI2km = (m = 0, fix = 2) => {
  return Number((m / 1.609344).toFixed(fix));
};

//  配速的秒/米转换成秒/丫的
export const paceM2yard = (m = 0, fix = 2, unit = Vue.prototype.$unit) => {
  if (unit === 0) {
    return Number(m.toFixed(fix));
  }
  return Number((m * 0.9144).toFixed(fix));
};

//  配速的（s/100m）转换成（s/km）
export const pace100mToKm = (m = 0, fix = 2) => {
  return Number((m * 10).toFixed(fix));
};

//  配速的（s/km）转换成（s/100m）
export const paceKmTo100m = (m = 0, fix = 2) => {
  return Number((m / 10).toFixed(fix));
};
// 生产配速范围数据
export const getPaceZone = (zoneData, ltsp) => {
  // index 对应于服务端返回数据的index
  // type 对应select选项的type
  // userZone 和 zone 通过type来对应
  let zone = [
    {
      // 积极恢复区
      name: 'G5019',
      color: '#00D2E6',
      ratio: 77,
      ratioRange: [0, 77],
      type: 7, // 显示层顺序
      index: 7 // 对应后端的index - 7 实际7 只在显示层追加
    },
    {
      // 有氧耐力区
      name: 'G3060',
      color: '#ff0055',
      ratio: 87,
      ratioRange: [77, 87], // 对应后端的index - 0
      type: 1,
      index: 0
    },
    {
      // 有氧动力区
      name: 'G3061',
      color: '#ff9900',
      ratio: 94,
      ratioRange: [87, 94],
      type: 2,
      index: 1
    },
    {
      // 乳酸阀区
      name: 'G3062',
      color: '#ffcc00',
      ratio: 108,
      ratioRange: [94, 108],
      type: 3,
      index: 2
    },
    // {
    //   // 超乳酸阀区
    //   name: 'G3063',
    //   color: '#00ff44',
    //   ratioRange: [100, 108],
    //   type: 4,
    //   index: 3
    // },
    {
      // 无氧耐力区
      name: 'G5016',
      color: '#00ffee',
      ratio: 118,
      ratioRange: [108, 118],
      type: 5,
      index: 4
    },
    {
      // 无氧动力区
      name: 'G5017',
      color: '#1199ee',
      ratio: 118,
      ratioRange: [118, ''],
      type: 6,
      index: 5
    }
  ];

  let userZone = cloneDeep(zoneData.ltspZone);
  const userZoneMap = {};
  if (userZone) {
    // userZone 服务端数据
    userZone.forEach((item) => {
      // type 客户端构造的参数, 用于对应select 选项
      userZoneMap[item.index] = item;
    });
    // 覆写积极恢复区
    const { ratio } = userZoneMap[0];
    zone[0].ratio = 0;
  }
  zone = zone.map((item) => {
    const { index, type, name, color, ratioRange, ratio } = item;
    const result = {
      name,
      defaultName: name,
      color,
      range: [0, 0],
      ratioRange,
      zoneInfo: {
        thresholdPace: 308
      },
      type,
      index,
      ratio
    };
    const defaultItem = userZone && userZoneMap[index];

    if (!defaultItem) {
      return result;
    }
    return {
      ...item,
      ...result,
      ...defaultItem
    };
  });
  if (!userZone) {
    return zone;
  }
  // 处理起始/终点
  const endIndex = zone.length - 1;
  const result = zone.map((item, index) => {
    let startRatio = zone[index].ratio;
    // 数值范围
    const shouldChange = ![0, endIndex].includes(index);
    let start = index === 0 ? '' : Math.round((ltsp * 100) / startRatio);

    const endRatio = zone[index + 1] ? zone[index + 1].ratio : zone[index].ratio;
    const end = index === endIndex ? '' : Math.round((ltsp * 100) / endRatio);

    if (shouldChange) {
      start = Number(start) - 1;
      startRatio = Number(startRatio) + 1;
    }

    item.range = [start, end];
    item.rangeText = `${secondToStr(start)}-${secondToStr(end)}`;
    item.ratioRange = [startRatio, endRatio];
    item.ratioRangeText = `${Math.round(startRatio)}%-${Math.round(endRatio)}%`;

    // 数值文本
    if (start === '') {
      item.rangeText = `>${secondToStr(end)}`;
    }
    if (end === '') {
      item.rangeText = `<${secondToStr(start)}`;
    }

    if (!start && !end) {
      item.rangeText = '';
    }

    // 比例文本
    if (endRatio === '') {
      item.ratioRangeText = `>${Math.round(startRatio)}%`;
    }

    if (!startRatio && !endRatio) {
      item.ratioRangeText = '';
    }

    return item;
  });
  return cloneDeep(result);
};
